<template>
<div class="jobs-container">
    <JobsPageBuilder :response="response" :vacancies="vacancies"></JobsPageBuilder>
</div>
</template>

<script>
import { JobsPageBuilder } from '@freddiesflowers/frontend-component-library';
import { getButterCmsPage } from '@/helpers/ButterCmsHelpers';
import VacancyService from '@/services/cms/VacancyService';

let vacancyService = new VacancyService();

export default {
    name: 'Jobs',
    data() {
        return {
            vacancies: [],
            response: null,
        };
    },
    computed: {
        areAvailableVacancies() {
            return this.vacancies.length > 0;
        },
    },
    created() {
        getButterCmsPage('jobs-page').then((res) => this.response = res);
    },
    mounted() {
        this.getAllVacancies();
    },
    methods: {
        async getAllVacancies() {
            this.vacancies = await vacancyService.getVacancies();
        },

        goToJobs() {
            this.$scrollTo('#availableJobs', { offset: -200 });
        },
    },
    components: { JobsPageBuilder },
};
</script>

<style lang="scss" scoped>
    .jobs-container {
        max-width: 850px;
        width: 80%;
        margin: 0px auto;
        padding-top: 100px;
    }
</style>
